import { Injectable } from "@angular/core";

import { catchError, map, Observable, throwError } from "rxjs";
import { ICarrierAreasSearchRequest, SearchCarrierAreasCommand } from "./command/searchCarrierAreas.command";
import { CreateCarrierAreaCommand, ICreateCarrierAreaRequest } from "./command/addCarrierArea.command";
import { IUpdateCarrierAreaRequest, UpdateCarrierAreaCommand } from "./command/updateCarrierArea.command";
import { DeleteCarrierAreaCommand, IDeleteCarrierAreaRequest } from "./command/deleteCarrierArea.command";
import { GetCarrierAreaCommand, IGetCarrierAreaRequest } from "./command/getCarrierArea.command";
import { GetControlAreasByPointCommand, IGetControlAreasByPointRequest } from "./command/getControlAreasByPoint.command";
import { CheckCarrierAreaByPointCommand, ICheckCarrierAreaByPointRequest } from "./command/checkCarrierAreaByPoint.command";
import { ConnectionServices } from "../authentication/connection/connection.service";
import { ICarrierAreaResponseDTO, IControlAreasByPointResponseDTO } from "../authentication/connection/interfaces/apiInterfaces";

@Injectable()
export class AreasService {
  constructor(
    private _connectionService: ConnectionServices,
  ) {}

  public searchCarrierAreas(
    request: ICarrierAreasSearchRequest
  ): Observable<ICarrierAreaResponseDTO[]> {
    const CarrierAreasSearchCommand = new SearchCarrierAreasCommand();
    CarrierAreasSearchCommand.setParameters({
      carrierId: request.carrierId,
      excludeOperationAreasInUse: request.excludeOperationAreasInUse,
      opeType: request.opeType
    });
    return this._connectionService
      .Request(CarrierAreasSearchCommand)
      .pipe(
        map((response: any) => Array.isArray(response) ? response : [response]),
        catchError(error => {
          return throwError(() => error);
        })
      )
  }

  public getCarrierAreas(
    request: IGetCarrierAreaRequest
  ): Observable<ICarrierAreaResponseDTO> {
    const getCarrierAreaCommand = new GetCarrierAreaCommand();
    getCarrierAreaCommand.setParameters({
      carrierId: request.carrierId,
      id: request.id,
    });
    return this._connectionService
      .Request(getCarrierAreaCommand)
      .pipe(
        map((response) => {
          // agregar notificación
          return response;
        }),
        catchError(error => {
          // agregar notificación
          return throwError(() => error);
        })
      )
  }

  public createCarrierArea(
    request: ICreateCarrierAreaRequest
  ): Observable<ICarrierAreaResponseDTO> {
    const createCarrierAreaCommand = new CreateCarrierAreaCommand();
    createCarrierAreaCommand.setParameters(request);
    return this._connectionService
      .Request(createCarrierAreaCommand)
      .pipe(
        map(response => {
        // add-notification
        return response;
        }),
        catchError(error => {
          // add-notification
          return throwError(() => error);
        })
      )
  }


  public updateCarrierArea(
    request: IUpdateCarrierAreaRequest
  ): Observable<void> {
    const updateCarrierAreaCommand = new UpdateCarrierAreaCommand();
    updateCarrierAreaCommand.setParameters(request);
    return this._connectionService
      .Request(updateCarrierAreaCommand)
      .pipe(
        map(() => {
        // add-notification
        return null;
        }),
        catchError(error => {
          // add-notification
          return throwError(() => error);
        })
      )
  }

  public deleteCarrierArea(
    request: IDeleteCarrierAreaRequest
  ): Observable<void> {
    const deleteCarrierAreaCommand = new DeleteCarrierAreaCommand();
    deleteCarrierAreaCommand.setParameters({
      carrierId: request.carrierId,
      id: request.id,
    });
    return this._connectionService
      .Request(deleteCarrierAreaCommand)
      .pipe(
        map(() => {
        // add-notification
        return null;
        }),
        catchError(error => {
          // add-notification
          return throwError(() => error);
        })
      )
  }

  public getControlAreasByPoint(
    request: IGetControlAreasByPointRequest
  ): Observable<IControlAreasByPointResponseDTO> {
    const getCarrierAreaCommand = new GetControlAreasByPointCommand();
    getCarrierAreaCommand.setParameters(request);
    return this._connectionService
      .Request(getCarrierAreaCommand)
      .pipe(
        map((response) => {
          return response;
        }),
        catchError(error => {
          return throwError(() => error);
        })
      )
  }

  public checkControlAreasByPoint(
    request: ICheckCarrierAreaByPointRequest
  ): Observable<boolean> {
    const getCarrierAreaCommand = new CheckCarrierAreaByPointCommand();
    getCarrierAreaCommand.setParameters(request);
    return this._connectionService
      .Request(getCarrierAreaCommand)
        .pipe(
        map((response: Boolean) => {
          return response as boolean;
        }),
        catchError(error => {
          return throwError(() => error);
        })
      )
  }
}
